/*
========================================
Null-Return IT Services & Consulting
========================================

Copyright (c) 2022 Null-Return IT Services & Consulting (https://www.nullreturn-it.com)

* Original page skeleton coded by Creative-Tim
* While the template offered had some amazing pre-build components, it did not include everything we needed
* We have built upon and expanded it with our own code and components to deliver a a great site to view our services!

=====================================
Material Kit 2 (initial base code)
=====================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Base components coded by www.creative-tim.com
*/

// Material Kit 2 React Base Styles
import colors from "assets/theme/base/colors";

const { info, dark } = colors;

export default {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};
